import { lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.tsx";
import { PrivateRoute } from "./components/auth/PrivateRoute.tsx";
import { PERMISOS } from "./constants/permissions.ts";
import { Toaster } from "./components/ui/sonner";
import { MasterDataLayout } from "./components/master-data/MasterDataLayout.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const LoginPage = lazy(() => import("./pages/Login.tsx"));
const DashboardPage = lazy(() => import("./pages/Dashboard.tsx"));
const DispensationPage = lazy(
  () => import("./features/dispensation/pages/DispensationPage.tsx"),
);
const UnsyncedOrdersPage = lazy(
  () => import("./features/unsynced-orders/pages/UnsyncedOrdersPage.tsx"),
);
const MinSaludSyncPage = lazy(
  () => import("./features/sync/pages/MinSaludSyncPage.tsx"),
);
const ServiceSanityPage = lazy(
  () => import("./features/service-sanity/pages/ServiceSanityPage.tsx"),
);
const TemplateRecipientsPage = lazy(
  () =>
    import("./features/template-recipients/pages/TemplateRecipientsPage.tsx"),
);
const ConciliationPage = lazy(
  () => import("./features/conciliation/pages/ConciliationPage.tsx"),
);
const ConciliationFileDetailPage = lazy(
  () => import("./features/conciliation/pages/ConciliationFileDetailPage.tsx"),
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MasterDataLayout>
                  <Home />
                </MasterDataLayout>
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.VER_GESTION}>
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="dispensation"
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.VER_GESTION}>
                  <DispensationPage />
                </PrivateRoute>
              }
            />
            <Route
              path="unsynced"
              element={
                <PrivateRoute
                  requiredPermission={
                    PERMISOS.MIPRES.ACTUALIZACION_MASIVA_SINCRONIZACION_BOT
                  }
                >
                  <UnsyncedOrdersPage />
                </PrivateRoute>
              }
            />
            <Route
              path="sync"
              element={
                <PrivateRoute
                  requiredPermission={
                    PERMISOS.MIPRES.ACTUALIZACION_MASIVA_SINCRONIZACION_BOT
                  }
                >
                  <MinSaludSyncPage />
                </PrivateRoute>
              }
            />
            <Route
              path="sanidad"
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.VER_GESTION}>
                  <ServiceSanityPage />
                </PrivateRoute>
              }
            />
            <Route
              path="email-recipients"
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.VER_GESTION}>
                  <TemplateRecipientsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="conciliation"
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.CONCILIACION_EXTERNA}>
                  <ConciliationPage />
                </PrivateRoute>
              }
            />
            <Route
              path="conciliation/:fileId"
              element={
                <PrivateRoute requiredPermission={PERMISOS.MIPRES.CONCILIACION_EXTERNA}>
                  <ConciliationFileDetailPage />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </StrictMode>,
);
